// Add your JS customizations here

jQuery(document).ready(function($) {
    // Hero page slider
    jQuery('.hero-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        fade: true,
        asNavFor: '.hero-thumbnail',
    });

    jQuery('.hero-thumbnail').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        asNavFor: '.hero-slider',
        arrows: false,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000    
    });

    // Image gallery
    jQuery('.image-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        asNavFor: '.image-thumbnail',
    });

    jQuery('.image-thumbnail').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        asNavFor: '.image-gallery',
        arrows: false,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000    
    });

    jQuery('.active-image-slides').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        centerMode: true,
        centerPadding: '0',
        infinite: true,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    
    // Testimonial slider
    jQuery('.testimonials').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        centerMode: true,
        centerPadding: '0',
        infinite: true,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    
    // Navigation menu
    var customArrow = jQuery(".main-nav .mega-sub-menu .widget_custom_html .title-menu a");
    jQuery(customArrow).after('<span class="down-arrow"></span>');

    jQuery('.mega-block-title').on('click', function() {
        var $menuContainer = jQuery(this).closest(".mega-menu-item");
        var isMenuOpen = $menuContainer.hasClass('open-menu');

        jQuery('.mega-menu-item').removeClass('open-menu').find('.menu-by-environment-container');
        jQuery('.mega-block-title').removeClass('up-arrow');
        jQuery(".widget_custom_html h4 .down-arrow").removeClass('up-arrow');

        if (!isMenuOpen) {
            $menuContainer.addClass('open-menu').find('.menu-by-environment-container');
            jQuery(this).addClass("up-arrow");
        }
    });
    function updateLink() {
        if (jQuery(window).width() < 1200) {
            jQuery('.mega-sub-menu .title-menu a').removeAttr('href');
        } 
    }
    updateLink();
    jQuery(window).resize(function() {
        updateLink();
    });
    jQuery('.widget_custom_html .title-menu').on('click', function() {
        var $menuContainer = jQuery(this).closest(".mega-menu-item").next();
        var isMenuOpen = $menuContainer.hasClass('open-menu');

        jQuery('.mega-menu-item').removeClass('open-menu').find('.menu-by-environment-container');
        jQuery(".widget_custom_html h4 .down-arrow").removeClass('up-arrow');
        jQuery('.mega-block-title').removeClass('up-arrow');

        if (!isMenuOpen) {
            $menuContainer.addClass('open-menu').find('.menu-by-environment-container');
            jQuery(this).find('span').addClass("up-arrow");
            // jQuery(this).addClass("up-arrow");
        }
    });

    jQuery(".innerpage-banner .banner-txt .icon").addClass("active");
    

    jQuery('.filter-row .form-control').on('click', function() {
        jQuery(this).parent().toggleClass('active');
    });

    // Listen for when the select box loses focus
    jQuery('.filter-row .form-control').on('blur', function() {
        jQuery(this).parent().removeClass('active');
    });
    

    // Video 
    jQuery("#videomodal").on('shown.bs.modal', function() {
        var iframe_src = jQuery(this).find('#video_iframe').attr('data-src');
        var iframe_title = jQuery(this).find('#video_iframe').attr('data-title');
        var videoid = iframe_src + '?autoplay=1';
        jQuery(this).find('#video_iframe iframe').remove();
        jQuery(this).find('#video_iframe').append('<iframe src="' + videoid + '" title="' + iframe_title + '"width="560" height="315"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    });
    jQuery("#videomodal").on('hide.bs.modal', function() {
        jQuery(this).find('#video_iframe iframe').remove();
    });

    if (jQuery(window).width() > 991) {
        var teambox = 0;
          setTimeout(function(){
            jQuery(".team-section .box").each(function(){
           if (jQuery(this).height() > teambox) { teambox = jQuery(this).height(); }
          });
          jQuery(".team-section .box").height(teambox);
          }, 1000);
    }

    // Expand and collapse Team Content
    jQuery('.team-section .read-more').hide();
    jQuery(function($) {
        $('.team-section .link-btn').click(function() {
            var $this = $(this); // caching the current button
            var $extraContent = $this.closest('.box');
            var $readMore = $extraContent.find('.read-more');

            
            jQuery($extraContent).height("");
            $this.toggleClass("morelink");
            $this.closest('.box').toggleClass('active');

            // Handling only the related ".read-more" content
            if ($readMore.hasClass('active')) {
                $readMore.removeClass('active').slideUp(300);
                $this.text('More');
            } else {
                // Slide up any active sections before sliding down the new one
                $('.read-more.active').slideUp(300).removeClass('active');
                // Also, reset all buttons to 'More' before changing the text of the clicked one to 'Less'
                $('.team-section .link-btn').text('More');

                $readMore.addClass('active').slideDown(300);
                $this.text('Less');
            }
        });
    });

    jQuery('.connect-with-expert .read-more').hide();
    jQuery(function($) {
        $('.connect-with-expert .expand .link-btn').click(function() {
            var $this = $(this); // caching the current button
            var $extraContent = $this.closest('.extra-content');
            var $readMore = $extraContent.find('.read-more');

            // Toggle the "morelink" class on the clicked button
            $this.toggleClass("morelink");

            // Handling only the related ".read-more" content
            if ($readMore.hasClass('active')) {
                $readMore.removeClass('active').slideUp(300);
                $this.text('More');
            } else {
                // Slide up any active sections before sliding down the new one
                $('.read-more.active').slideUp(300).removeClass('active');
                // Also, reset all buttons to 'More' before changing the text of the clicked one to 'Less'
                $('.connect-with-expert .expand .link-btn').text('More');

                $readMore.addClass('active').slideDown(300);
                $this.text('Less');
            }
        });
    });


    // Fancybox
    jQuery('[data-fancybox]').fancybox({
      // Options will go here
      buttons : [
        'close'
      ],
      wheel : false,
      transitionEffect: "slide",
       // thumbs          : false,
      // hash            : false,
      loop            : true,
      // keyboard        : true,
      toolbar         : false,
      // animationEffect : false,
      // arrows          : true,
      clickContent    : false
    });

    
    if ($(".timeline-section").hasClass("vertical")) {

        function adjustProgress() {
            var progressElement = document.getElementById('progress');
            var timelineSection = $('.timeline-section');
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            var middleOfWindow = windowHeight / 2;
            var timelineOffset = timelineSection.offset().top;

            // When the top of the timeline-section is visible at the middle of the viewport
            if (timelineOffset < (scroll + middleOfWindow)) {
                var maxProgressHeight = timelineSection.outerHeight();
                var progress = ((scroll + middleOfWindow) - timelineOffset) / maxProgressHeight * 100;
                progressElement.style.height = Math.min(progress, 100) + '%';
            } else {
                progressElement.style.height = '0%';
            }
        }

        function toggleActiveClassOnBoxes() {
            var windowHeight = $(window).height();
            var middleOfWindow = windowHeight / 2;
            var scroll = $(window).scrollTop();

            // Check each box in the timeline
            $('.timeline .box').each(function() {
                var box = $(this);
                var boxTopOffset = box.offset().top;

                // When the top of the box is visible at the middle of the viewport
                if (boxTopOffset < (scroll + middleOfWindow)) {
                    box.addClass('active');
                } else {
                    box.removeClass('active');
                }
            });
        }

        // Bind the scroll events to the window
        function initScrollEvents() {
            $(window).on('scroll', function() {
                adjustProgress();
                toggleActiveClassOnBoxes();
            });
        }

        // Initial setup
        $(window).on('load', function() {
            // Initialize scroll-dependent functions
            initScrollEvents();
            // Run the progress and active box check once at start
            adjustProgress();
            toggleActiveClassOnBoxes();
        });

    }
    
});


// Counter START
if (jQuery("#counter-box").hasClass("counter-box")) {
    var a = 0;
    jQuery(window).scroll(function () {
        var oTop = jQuery("#counter-box").offset().top - window.innerHeight;
        if (a == 0 && jQuery(window).scrollTop() > oTop) {
            jQuery(".counter").each(function () {
                var $this = jQuery(this),
                    countTo = $this.attr("data-number");
                jQuery({
                    countNum: $this.text()
                }).animate({
                    countNum: countTo
                }, {
                    duration: 4000,
                    easing: "swing",
                    step: function () {
                        //$this.text(Math.ceil(this.countNum));
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("en")
                        );
                    },
                    complete: function () {
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("en")
                        );
                    }
                });
            });
            a = 1;
        }
    });
}